export default __webpack_public_path__ + "media/zurb/img/legacy/spur/spur-large-2bf98ce37c31f59a1416e9bcd9c4c19e.png";